module.exports = function anonymous(it
/**/) {
var out='<div id="time-delay" class="ui-slider"> <div class="ui-slider-segment"></div> <div class="ui-slider-segment"></div> <div class="ui-slider-segment"></div></div>';return out;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/dot-loader!./browser/library/js/templates/time-delay-ctrl.tpl
 ** module id = 491
 ** module chunks = 1
 **/